import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f1077b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../../../assets/logo.png"
}, null, -1))
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<span class=\"main_field bold\" data-v-2f1077b4>Поздравляем с подготовкой документа!</span><div class=\"hint_left hint_mini_top\" data-v-2f1077b4> Выберите удобный способ вывода документа и можете продолжать работать. </div><div class=\"hint_left hint_mini_top\" data-v-2f1077b4>Всего доброго!</div><br data-v-2f1077b4><span class=\"main_field\" data-v-2f1077b4>11. Сохранение документа</span><div class=\"hint_left\" style=\"margin-top:10px;\" data-v-2f1077b4> Введите под каким именем сохранить </div>", 6)
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, " Сохраните разбитый по приложениям документ ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hint_left",
  style: {"margin-top":"68px"}
}, " Сохраните документ одним файлом ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = {
  key: 0,
  alt: "loading...",
  class: "loading",
  src: "../../../../assets/loading.gif"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        class: "first_input",
        placeholder: "например - \"дизайн проект №7\"",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.info_save) = $event))
      }, null, 512), [
        [_vModelText, _ctx.info_save]
      ]),
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _createElementVNode("button", {
        type: "button",
        class: "blue_btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.download_separated && _ctx.download_separated(...args))),
        style: {"float":"left","margin-left":"10px"}
      }, " Сохранить по приложениям "),
      _hoisted_12,
      _createElementVNode("button", {
        type: "button",
        class: "blue_btn",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.download_all && _ctx.download_all(...args))),
        style: {"float":"left","margin-left":"10px"}
      }, " Сохранить документ "),
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      (_ctx.load_process)
        ? (_openBlock(), _createElementBlock("img", _hoisted_16))
        : _createCommentVNode("", true),
      _hoisted_17,
      _hoisted_18,
      _createElementVNode("button", {
        type: "button",
        class: "white_btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.go_step1())),
        style: {"float":"left","margin-left":"10px"}
      }, " Создать новый документ "),
      _hoisted_19,
      _hoisted_20,
      _hoisted_21,
      _createElementVNode("button", {
        type: "button",
        class: "white_btn",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.go_list())),
        style: {"float":"left","margin-left":"10px"}
      }, " Переход к сохранённым документам ")
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.go_back()))
    }, "Назад")
  ], 64))
}